export default new Intl.DateTimeFormat('ru', {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit'
})
